import { connect } from "react-redux";
import BookingAside from "./BookingAside.jsx";
import get from "lodash/get";
import { shouldEnableFlexRateChoice } from "app/pages/Booking/Quotation/flexSelectors";
import {
	checkIsCreditUsageIsEnabled,
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = (state, ownProps) => {
	const isQuotationFormSubmitting = get(state, "form.booking-quotation-form._submitting", false);
	const currentPathname = ownProps.location.pathname;
	const isPagePayment = matchPath(
		{
			path: "/booking/payment",
		},
		currentPathname
	);
	const isSDPPagePayment = matchPath(
		{
			path: "/sdp/booking/payment",
		},
		currentPathname
	);
	const isRestoreBookingSessionPage = matchPath(
		{
			path: "/booking/restoreSession",
		},
		currentPathname
	);
	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const total = calculatePreBookTotal(state) - creditsApplied;

	return {
		shop: state.shop,
		total: total,
		quotation: state.quotation,
		ficheProduit: state.ficheProduit,
		depositPercentage: getPartnerDepositPercentage(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableFlexRateChoice: shouldEnableFlexRateChoice(state),
		isSubmitting: isQuotationFormSubmitting,
		availablePaymentTerms: getAvailablePaymentTerms(state),
		isPagePayment: isPagePayment || isSDPPagePayment || isRestoreBookingSessionPage,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
	};
};

export default withRouter(connect(mapStateToProps)(BookingAside));
